+<template>
    <div v-if="show && loaded" class="nevs-popup-container">
        <div class="nevs-popup">
            <div class="popup-form">
                <NevsDateField v-model="startDate" :error="validation.start_date"
                               :label="'*' + $LANG.Get('fields.startDate') + ':'"></NevsDateField>
                <NevsDateField v-model="endDate" :error="validation.end_date"
                               :label="'*' + $LANG.Get('fields.endDate') + ':'"></NevsDateField>
                <NevsTextField v-model="reason" :error="validation.reason"
                               :label="$LANG.Get('fields.pauseReason') + ':'"></NevsTextField>
                <div class="pause-disclaimer">
                    <i class="fa-solid fa-circle-info"></i>
                    <span>{{ $LANG.Get('texts.pauseDisclaimer') }}</span>
                </div>
            </div>
            <div class="nevs-popup-buttons">
                <NevsButton class="error" @click="cancelClick()">
                    <i class="fa-solid fa-xmark"></i>
                    {{ $LANG.Get('buttons.cancel') }}
                </NevsButton>
                <NevsButton class="success" @click="okClick()">
                    <i class="fa-solid fa-check"></i>
                    {{ $LANG.Get('buttons.ok') }}
                </NevsButton>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsDateField from "@/components/nevs/NevsDateField.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";

export default {
    name: "ModalEditPersonPause",
    components: {NevsTextField, NevsDateField, NevsButton},
    props: {
        show: {
            type: Boolean,
            default: false
        },
        personId: {
            type: [Number, String],
            default: null
        },
        pause: {
            type: Object,
            default: null
        }
    },
    emits: ['done'],
    data() {
        return {
            loaded: false,
            startDate: '',
            endDate: '',
            reason: '',
            validation: {
                start_date: '',
                end_date: '',
                reason: ''
            }
        }
    },
    watch: {
        show() {
            this.loaded = false;
            this.validation = {start_date: '', end_date: '', reason: ''};
            if (this.show) {
                if (this.pause !== null) {
                    this.startDate = this.pause.start_date;
                    this.endDate = this.pause.end_date;
                    this.reason = this.pause.reason;
                } else {
                    this.startDate = moment().format('YYYY-MM-DD');
                    this.endDate = '';
                    this.reason = '';
                }
                this.$nextTick(() => {
                    this.loaded = true;
                });
            }
        }
    },
    methods: {
        cancelClick() {
            this.$emit('done', false);
        },
        okClick() {
            let valid = true;
            // Both ends are required: an open-ended pause could not be turned into a membership extension.
            if (this.startDate === '' || this.startDate === null) {
                this.validation.start_date = this.$LANG.Get('labels.mandatoryField');
                valid = false;
            } else {
                this.validation.start_date = '';
            }
            if (this.endDate === '' || this.endDate === null) {
                this.validation.end_date = this.$LANG.Get('labels.mandatoryField');
                valid = false;
            } else if (this.endDate < this.startDate) {
                // Dates are YYYY-MM-DD, so plain string comparison orders them correctly.
                this.validation.end_date = this.$LANG.Get('labels.endDateBeforeStartDate');
                valid = false;
            } else {
                this.validation.end_date = '';
            }
            if (!valid) {
                return;
            }

            let vm = this;
            let method = this.pause === null ? 'post' : 'put';
            let action = this.pause === null ? 'person-pauses' : 'person-pauses/' + this.pause.id;
            this.$API.APICall(method, action, {
                person_id: this.personId,
                start_date: this.startDate,
                end_date: this.endDate,
                reason: this.reason
            }, (data, success) => {
                if (success) {
                    vm.$emit('done', true);
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        }
    }
}
</script>

<style scoped lang="scss">
@use '../../scss/vars' as *;

.nevs-popup {
    max-width: 500px;
}

.popup-form {
    padding: 10px;
}

.pause-disclaimer {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    background-color: $warning-surface;
    border: 1px solid $warning-border;
    color: $warning-ink;
    border-radius: 5px;
    padding: 12px 14px;
    margin-top: 15px;
    font-size: 0.9em;
    line-height: 1.45;
}

.pause-disclaimer i {
    margin-top: 2px;
    flex-shrink: 0;
}
</style>
